import { Injectable } from '@angular/core';
import { Api } from '../api/api';

@Injectable()
export class Dokumen {

  file_url = '';
  constructor(public api:Api) { 
    this.file_url = api.url+"/client/uploads/";
  }


  post(params?: any) {
    return this.api.post('index.php/document', params);
  }

}


// WEBPACK FOOTER //
// ./src/providers/asset/dokumen/dokumen.ts